import { Component } from '@angular/core';
import { HeaderLogoResponse, HeaderService } from '../header/header.service';
import { FooterLinkResponse, FooterLinkService } from './footer.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
	selector: 'vcm-app-footer',
	template: require('./footer.component.html'),
})

export class FooterComponent {
	headerLogoResponse: HeaderLogoResponse;
	footerLinkResponse: FooterLinkResponse;
	linksSafe: SafeHtml[] = [];

	constructor(private headerService: HeaderService, private footerLinkService: FooterLinkService, private sanitizer: DomSanitizer) {
		this.headerService.getLogo().then((res: HeaderLogoResponse) => {
			this.headerLogoResponse = res;
		});

		this.footerLinkService.getFooterLink().then((res: FooterLinkResponse) => {
			console.log(res);
			this.footerLinkResponse = res;

			this.linksSafe = res.Links.map(link => {
    			return this.isJavascriptLink(link) ? this.sanitizerHTML(link) : link;
			});
		});
	}

	isJavascriptLink(link: string): boolean {
		return link.includes("javascript");
	}

	sanitizerHTML(html: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(html);
	}
}
